"use client";

import { useEffect, useRef, useState } from "react";
import {
  Form,
  Button,
  Steps,
  Select,
  Row,
  Col,
  UploadFile,
  Skeleton,
  Spin,
  Flex,
  Modal,
  Tag,
} from "antd"; // Import the 'App' component
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { addVisite } from "../../store/slices/visiteSlice";
import { useDispatch } from "react-redux";
import {
  completeProject,
  editProject,
  editTranche,
  fetchProjectsNames,
  retirerProject,
} from "../../store/slices/projectSlice";
import * as S from "./Multistepform.styles";

import InformationVisiteStep from "./steps/InformationVisiteStep";
import { PresentationProjetStep } from "./steps/PresentationProjetStep";
import { CaracteristiquesProjetStep } from "./steps/CaracteristiquesProjetStep";
import { CommercialisationStep } from "./steps/CommercialisationStep";
import { CaracteristiqueUniteesStep } from "./steps/CaracteristiqueUniteesStep";
import { InformationsDesVentesStep } from "./steps/InformationsDesVentesStep";
import dayjs from "dayjs";
import { RcFile } from "antd/es/upload";
import { uploadPhotosApi } from "../../api/photos.api";
import { fetchUsersWithProjects } from "../../store/slices/userSlice";
import { useMediaQuery } from "react-responsive";
import {
  CheckOutlined,
  LeftCircleOutlined,
  LoadingOutlined,
  ReloadOutlined,
  RightCircleOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import {
  createProgrammationAppartements,
  createProgrammationBureaux,
  createProgrammationLocauxCommerciaux,
  createProgrammationVillas,
} from "../../store/slices/programmationSlice";
import {
  addBrouillonApi,
  getBrouillonApi,
  resetBrouillonApi,
} from "../../api/users.api";
import {
  prepareDayjsFieldsForStorage,
  restoreDayjsFields,
} from "../../helpers/drafthelpers";
import { UploadStep } from "./steps/UploadStep";
import { validateAllPropertyTotals } from "../../helpers/validationHelpers";
const { Step } = Steps;
const { Option } = Select;

export default function MultiStepFormV2() {
  const [current, setCurrent] = useState(0);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [draftLoaded, setDraftLoaded] = useState(false);

  

  const [fileListBureauVente, setFileListBureauVente] = useState<UploadFile[]>(
    []
  );
  const [fileListExterieurProjet, setFileListExterieurProjet] = useState<
    UploadFile[]
  >([]);
  const [fileListTemoins, setFileListTemoins] = useState<UploadFile[]>([]);
  const [fileListPiscine, setFileListPiscine] = useState<UploadFile[]>([]);
  const [fileListParking, setFileListParking] = useState<UploadFile[]>([]);
  const [fileListChantier, setFileListChantier] = useState<UploadFile[]>([]);
  const [fileListEquipementSportif, setFileListEquipementSportif] = useState<
    UploadFile[]
  >([]);
  const [fileListAutres, setFileListAutres] = useState<UploadFile[]>([]);
  const user = useSelector((state: RootState) => state.auth.user); // Access the user from Redux state
  const { usersWithProjects,all_projects } = useSelector((state: RootState) => state.user); // Access the projects from Redux state\
  // Find the connected user's object in usersWithProjects
  const connectedUser = usersWithProjects.find((u) => u.id === user?.id);

  // Logic of projets and tranches **************************
  // Get the projects of the connected user (or an empty array if none are found)
  const [userProjects, setUserProjects] = useState(() => {
    // If user is admin or controleur, show all projects
    if (user?.role === 'admin' || user?.role === 'controleur') {
      return all_projects || [];
    } 
    // Otherwise, show only the user's projects
    return connectedUser?.projets || [];
  });

  


  // Filter projects where etat_projet !== "visité"
  const filteredProjects = userProjects.filter(
    (project) => project.etat_projet !== "actualisé"
  );

  // Map filtered projects to options
  const projectOptions = userProjects.map((project) => ({
    value: project.id,
    label:  `${project.nom} (${project.etat_projet})`,
  }));
  const [isParTranche, setIsParTranche] = useState(false);
  const [tranchesOptions, setTranchesOptions] = useState<Record<string, any>[]>(
    []
  );

  // Logic of projets and tranches **************************

  const dateFormat = "DD/MM/YYYY";

  const initialState = {
    date_visite: null,
    utilisateur: user?.id, //visite generale
    nom_visiteur: user?.prenom + " " + user?.nom, // doesnt go to the database
    fk_nom_du_projet: null, // a modifier to fk_tranche pour la visite
    fk_tranche: null as number | null,
    bureau_de_vente: null, //visite generale
    contact_agent_commercial: "", //visite generale
    date_debut_commercialisation: null, // to update tranche
    date_fin_commercialisation: null, // to update tranche
    livraison_immediate: false,
    date_livraison: null, // to update tranche
    etat_des_ventes: null as string|null, // to update tranche

    //////////////////////////
    pratique_noir: null, //visite

    // Données du projet
    promoteur: "", // to update metaProject
    composants: [], // to update Tranche
    usage: [], // to update Tranche
    cloturee: null, // to update Tranche
    type_de_standing: "", // to update Tranche
    phase_du_projet: "", // to update Tranche
    etat_avancement: null, // to update Tranche
    nbr_tranches: null, // to remove
    nbr_unites_appartements: null, // to update Tranche
    nbr_unites_villas: null, // to update Tranche
    nbr_unites_bureaux: null, // to update Tranche
    nbr_unites_lc: null, // to update Tranche
    espace_vert: false, // to update Tranche
    piscine: false, // to update Tranche
    salle_de_sport: false, // to update Tranche
    terrain_de_sport: false, // to update Tranche
    creche: false,
    ///
    nbr_etages: null,
    ascenseur: false, // à ajouter dans le backend
    nbr_d_ascenseurs: null,
    sous_sol: false,
    nbr_de_sous_sol: null,
    parking_appartements: false,
    nbr_de_place_de_parking_appartements: null,
    parking_villas: false,
    nbr_de_place_de_parking_villas: null,

    //Caracteristiques unites
    appartements: [],
    villas: [],
    bureaux: [],
    locaux_commerciaux: [],

    appartements_prices: [],
    nbr_unites_appartements_vendues: null,
    nbr_unites_appartements_invendues: null,
    villas_prices: [],
    nbr_unites_villas_vendues: null,
    nbr_unites_villas_invendues: null,
    bureaux_prices: [],
    nbr_unites_bureaux_vendues: null,
    nbr_unites_bureaux_invendues: null,
    locaux_commerciaux_prices: [],
    nbr_unites_lc_vendues: null,
    nbr_unites_lc_invendues: null,

    // to change logic ***********************
    photos: null,
  };
  const [formData, setFormData] = useState(initialState);
  const [isSousSolExistant, setIsSousSolExistant] = useState(false);
  const [isParkingAppartementsAvailable, setIsParkingAppartementsAvailable] =
    useState(false);
  const [isParkingVillasAvailable, setIsParkingVillasAvailable] =
    useState(false);
  const [isAscenseurAvailable, setIsAscenseurAvailable] = useState(false);

  const [isEnChantier, setIsEnChantier] = useState(false);

  const dispatch = useDispatch();
  const handleValuesChange = (changedValues: any, allValues: any) => {
    setFormData((prev) => ({ ...prev, ...allValues }));

    // selection du projet
    if (changedValues.fk_nom_du_projet) {
      const projectID = changedValues.fk_nom_du_projet;
      const projet = userProjects.find((project) => project.id === projectID);
      console.log(projet);

      // Always clear the tranche selection when switching projects
      form.setFieldsValue({ fk_tranche: null });
      setFormData((prev: any) => ({ ...prev, fk_tranche: null }));

      if (projet) {
        if (projet.type_realisation === "En totalité") {
          setIsParTranche(false);
          setTranchesOptions([]);
          // If you want auto-selection, update the form and state:
          const autoTranche = projet.tranches[0]?.id || null;
          form.setFieldsValue({ fk_tranche: autoTranche });
          setFormData((prev: any) => ({ ...prev, fk_tranche: autoTranche }));
          console.log("fk_tranche ", autoTranche);
        } else {
          setIsParTranche(true);
          // Leave fk_tranche cleared until user selects one
          form.setFieldsValue({ fk_tranche: null });
          if (projet) {
            setTranchesOptions(
              projet.tranches
                .filter((tranche:any) => tranche.a_visiter && tranche.suivi_initial) // Only include non-visited tranches
                .map((tranche:any) => ({
                  label: tranche.is_visited 
                  ? `${tranche.name} (Visitée ${tranche.is_updated ? '& À jour' : 'mais pas à jour'})`
                  : `${tranche.name} (Non visitée)`,
                  value: tranche.id,
                }))
            );
          }
        }
      }
    }

    // logic if user change the composants select
    if (changedValues.composants) {
      if (!changedValues.composants.includes("locaux commerciaux")) {
        setFormData((prev: any) => ({
          ...prev,
          locaux_commerciaux: [],
          nbr_unites_lc: null,
          nbr_unites_lc_invendues: null,
          nbr_unites_lc_vendues: null,
        }));
      }
      if (!changedValues.composants.includes("villas")) {
        setFormData((prev: any) => ({
          ...prev,
          villas: [],
          nbr_unites_villas: null,
          nbr_unites_villas_invendues: null,
          nbr_unites_villas_vendues: null,
          parking_villas: false,
          nbr_de_place_de_parking_villas: null,
        }));
        setIsParkingVillasAvailable(false);
      }
      if (!changedValues.composants.includes("appartements")) {
        setFormData((prev: any) => ({
          ...prev,
          appartements: [],
          nbr_unites_appartements: null,
          nbr_unites_appartements_invendues: null,
          nbr_unites_appartements_vendues: null,
          parking_appartements: false,
          nbr_de_place_de_parking_appartements: null,
        }));
        setIsParkingAppartementsAvailable(false);
      }
      if (!changedValues.composants.includes("bureaux")) {
        setFormData((prev: any) => ({
          ...prev,
          bureaux: [],
          nbr_unites_bureaux: null,
          nbr_unites_bureaux_invendues: null,
          nbr_unites_bureaux_vendues: null,
        }));
      }
    }

    // par tranche
    if (changedValues.phase_du_projet !== undefined) {
      const isEnChantier = changedValues.phase_du_projet === "en chantier";
      setIsEnChantier(isEnChantier);

      if (!isEnChantier) {
        setFormData((prev) => ({ ...prev, etat_avancement: null }));
        form.setFieldsValue({ etat_avancement: null });
      }
    }

    // ascenseur
    if (changedValues.ascenseur !== undefined) {
      const isAvailable = changedValues.ascenseur === true;
      setIsAscenseurAvailable(isAvailable);

      if (!isAvailable) {
        setFormData((prev) => ({ ...prev, nbr_d_ascenseurs: null }));
        form.setFieldsValue({ nbr_d_ascenseurs: null });
      }
    }

    // sous-sol
    if (changedValues.sous_sol !== undefined) {
      const isExistant = changedValues.sous_sol === true;
      setIsSousSolExistant(isExistant);

      if (!isExistant) {
        setFormData((prev) => ({ ...prev, nbr_de_sous_sol: null }));
        form.setFieldsValue({ nbr_de_sous_sol: null });
      }
    }
    // parking appartements
    if (changedValues.parking_appartements !== undefined) {
      const isAvailable = changedValues.parking_appartements === true;
      setIsParkingAppartementsAvailable(isAvailable);
    
      if (!isAvailable) {
        setFormData((prev:any) => ({
          ...prev,
          nbr_de_place_de_parking_appartements: null,
          appartements_prices: prev.appartements_prices?.map((app: any, index: number) => ({
            ...app,
            isPrixParkingInclus: true,
            prixParking: null,
          })) || [],
        }));
    
        // Update Ant Design Form List
        const updatedAppPrices = form.getFieldValue("appartements_prices")?.map(
          (app: any) => ({
            ...app,
            isPrixParkingInclus: true,
            prixParking: null,
          })
        ) || [];
    
        form.setFieldsValue({ 
          nbr_de_place_de_parking_appartements: null,
          appartements_prices: updatedAppPrices 
        });
      }
    }

    // parking villas
    if (changedValues.parking_villas !== undefined) {
      const isAvailable = changedValues.parking_villas === true;
      setIsParkingVillasAvailable(isAvailable);
    
      if (!isAvailable) {
        setFormData((prev:any) => ({
          ...prev,
          nbr_de_place_de_parking_villas: null,
          villas_prices: prev.villas_prices?.map((villa: any, index: number) => ({
            ...villa,
            isPrixParkingInclus: true,
            prixParking: null,
          })) || [],
        }));
    
        // Update Ant Design Form List
        const updatedVillasPrices = form.getFieldValue("villas_prices")?.map(
          (villa: any) => ({
            ...villa,
            isPrixParkingInclus: true,
            prixParking: null,
          })
        ) || [];
    
        form.setFieldsValue({ 
          nbr_de_place_de_parking_villas: null,
          villas_prices: updatedVillasPrices 
        });
      }
    }
    
    

    // livraison immediate
    if (changedValues.livraison_immediate === true) {
      setFormData((prev) => ({ ...prev, date_livraison: null }));
      form.setFieldsValue({ date_livraison: null });
    } 

    if (changedValues.etat_des_ventes === "commercialisation non initiée") {
      setFormData((prev) => ({ ...prev, date_debut_commercialisation: null, date_fin_commercialisation: null }));
      form.setFieldsValue({ date_debut_commercialisation: null, date_fin_commercialisation: null });
    }
    // livre avec commercialisation
    if (changedValues.etat_des_ventes === "commercialisation achevée") {
      setFormData((prev) => ({ ...prev, phase_du_projet: "livré" }));
      form.setFieldsValue({  phase_du_projet: "livré" });
    } 
    if (changedValues.phase_du_projet === "livré") {
      setFormData((prev) => ({ ...prev, etat_des_ventes: "commercialisation achevée" }));
      form.setFieldsValue({  etat_des_ventes: "commercialisation achevée" });
    }   
    // photos
    if (changedValues.bureau_de_vente !== "disponible") {
      setFileListBureauVente([]);
    }
    if (changedValues.phase_du_projet !== "en chantier") {
      setFileListChantier([]);
    }
    if (changedValues.piscine !== true) {
      setFileListPiscine([]);
    }
    if (!allValues.parking_appartements && !allValues.parking_appartements) {
      setFileListParking([]);
    }
    if (!allValues.salle_de_sport && !allValues.terrain_de_sport) {
      setFileListEquipementSportif([]);
    }
  };

  const steps = [
    {
      title: "Informations de la visite",
      content: (
        <InformationVisiteStep
          form={form}
          options={projectOptions}
          dateFormat={dateFormat}
          isParTranche={isParTranche}
          trancheOptions={tranchesOptions}
        />
      ),
    },
    {
      title: "Présentation du projet",
      content: (
        <PresentationProjetStep
          form={form}
          typeDeProjet={formData.composants}
        />
      ),
    },
    {
      title: "Caractéristiques du projet",
      content: (
        <CaracteristiquesProjetStep
          form={form}
          typeDeProjet={formData.composants}
          isAscenseurAvailable={isAscenseurAvailable}
          isParkingAppartementsAvailable={isParkingAppartementsAvailable}
          isParkingVillasAvailable={isParkingVillasAvailable}
          isSousSolExistant={isSousSolExistant}
          isEnChantier={isEnChantier}
        />
      ),
    },
    {
      title: "Commercialisation du projet",
      content: (
        <CommercialisationStep
          formData={formData}
          dateFormat={dateFormat}
          form={form}
        />
      ),
    },
    {
      title: "Caractéristiques des unités",
      content: (
        <CaracteristiqueUniteesStep
          form={form}
          formData={formData}
          setFormData={setFormData}
          typeDeProjet={formData.composants}
        />
      ),
    },

    {
      title: "Informations des ventes",
      content: (
        <InformationsDesVentesStep
          form={form}
          formData={formData}
          typeDeProjet={formData.composants}
          setFormData={setFormData}
        />
      ),
    },
    {
      title: "Images",
      content: (
        <UploadStep
          form={form}
          formData={formData}
          setFormData={setFormData}
          fileListBureauVente={fileListBureauVente}
          setFileListBureauVente={setFileListBureauVente}
          fileListExterieurProjet={fileListExterieurProjet}
          setFileListExterieurProjet={setFileListExterieurProjet}
          fileListTemoins={fileListTemoins}
          setFileListTemoins={setFileListTemoins}
          fileListPiscine={fileListPiscine}
          setFileListPiscine={setFileListPiscine}
          fileListParking={fileListParking}
          setFileListParking={setFileListParking}
          fileListChantier={fileListChantier}
          setFileListChantier={setFileListChantier}
          fileListEquipmentSportif={fileListEquipementSportif}
          setFileListEquipmentSportif={setFileListEquipementSportif}
          fileListAutres={fileListAutres}
          setFileListAutres={setFileListAutres}
        />
      ),
    },
  ];

  const scrollToFormTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const next = async () => {
    try {
      const currentFields = await form.validateFields();

      setFormData({
        ...formData,
        ...currentFields,
      });
      console.log("test")
     // Si nous sommes à l'étape des prix des propriétés (étape 5)
    if (current === 5) {
      // Valider tous les types de propriétés
      const validation = validateAllPropertyTotals(formData, form);
      
      if (!validation.isValid) {
        // Format error messages with bullet points
        const formattedErrors = validation.errors.map(error => `- ${error}`).join('\n');
        
        // Show error modal with all errors
        Modal.error({
          title: 'Erreurs de validation',
          content: (
            <div style={{ maxHeight: '300px', overflow: 'auto' }}>
              <p>Veuillez corriger les erreurs suivantes:</p>
              <pre style={{ whiteSpace: 'pre-wrap', margin: '10px 0' }}>
                {formattedErrors}
              </pre>
            </div>
          ),
          width: 600,
          okText: 'Corriger',
        });
        return; // Arrêter la progression vers l'étape suivante
      }
    }

      console.log("formData", formData);
      console.log(formData.date_debut_commercialisation);
      console.log(formData.date_fin_commercialisation);
      // if step === 5 addlofig here

      // Move to next step
      if (current < steps.length - 1) {
        setCurrent(current + 1);
      }
    } catch (error) {
      console.error("Validation failed:", error);
      toast.error("Vérifiez vos données avant de passer au suivant.");
    }
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  // Define a reusable function for uploading photos by category
  const uploadPhotosByCategory = async (
    fileList: UploadFile[] | undefined,
    visiteId: number | string,
    category: string
  ): Promise<void> => {
    if (fileList && fileList.length > 0) {
      const uploadFormData = new FormData();

      fileList.forEach((file: UploadFile) => {
        if (file.originFileObj) {
          uploadFormData.append("photos", file.originFileObj);
        }
      });

      uploadFormData.append("fk_visite_generale", visiteId.toString());
      uploadFormData.append("category", category);

      await uploadPhotosApi(uploadFormData);
    }
  };

  const onFinish = async () => {
    try {
      await toast.promise(
        (async () => {
          const currentFields = await form.validateFields();
          const finalFormData = { ...formData, ...currentFields };

          // Process arrays and dates
          const processedFormData = {
            ...finalFormData,
            usage: Array.isArray(finalFormData.usage)
              ? finalFormData.usage.join(",")
              : finalFormData.usage,
            composants: Array.isArray(finalFormData.composants)
              ? finalFormData.composants.join(",")
              : finalFormData.composants,
            date_visite: finalFormData.date_visite
              ? dayjs(finalFormData.date_visite).format(dateFormat)
              : null,
            date_debut_commercialisation:
              finalFormData.date_debut_commercialisation
                ? dayjs(finalFormData.date_debut_commercialisation).format(
                    dateFormat
                  )
                : null,
            date_fin_commercialisation: finalFormData.date_fin_commercialisation
              ? dayjs(finalFormData.date_fin_commercialisation).format(
                  dateFormat
                )
              : null,
            date_livraison: finalFormData.date_livraison
              ? dayjs(finalFormData.date_livraison).format(dateFormat)
              : null,
          };

          // Remove nom_visiteur (not stored in DB)
          const { nom_visiteur, ...filteredFormData } = processedFormData;

          const metaProjectData = { promoteur: filteredFormData.promoteur };
          const trancheData = { ...filteredFormData, is_visited: true };

          // --- Step 1: Update Project ---
          await dispatch(
            editProject({
              newProject: metaProjectData,
              id: filteredFormData.fk_nom_du_projet,
            })
          );

          // --- Step 2: Update Tranche ---
          await dispatch(
            editTranche({
              newTranche: trancheData,
              id: filteredFormData.fk_tranche,
            })
          );

          // --- Step 3: Create Programmations ---
          const programmationLists: any = {
            appartements: filteredFormData.appartements || [],
            villas: filteredFormData.villas || [],
            bureaux: filteredFormData.bureaux || [],
            locaux_commerciaux: filteredFormData.locaux_commerciaux || [],
          };

          const fk_tranche = formData.fk_tranche;
          Object.keys(programmationLists).forEach((key) => {
            const list = programmationLists[key];
            if (list.length > 0) {
              programmationLists[key] = list.map((item: any) => ({
                ...item,
                fk_tranche,
              }));
            }
          });

          const programmationIds = {
            appartements: [],
            villas: [],
            bureaux: [],
            locaux_commerciaux: [],
          };

          if (programmationLists.appartements.length > 0) {
            const resApp = await dispatch(
              createProgrammationAppartements(programmationLists.appartements)
            );
            programmationIds.appartements = resApp.payload;
          }
          if (programmationLists.villas.length > 0) {
            const resVillas = await dispatch(
              createProgrammationVillas(programmationLists.villas)
            );
            programmationIds.villas = resVillas.payload;
          }
          if (programmationLists.bureaux.length > 0) {
            const resBureaux = await dispatch(
              createProgrammationBureaux(programmationLists.bureaux)
            );
            programmationIds.bureaux = resBureaux.payload;
          }
          if (programmationLists.locaux_commerciaux.length > 0) {
            const resLC = await dispatch(
              createProgrammationLocauxCommerciaux(
                programmationLists.locaux_commerciaux
              )
            );
            programmationIds.locaux_commerciaux = resLC.payload;
          }

          // --- Step 4: Create Visite + Upload Photos ---
          const donnees_visites_specifiques: any[] = [];

          // Add appartements prices
          if (programmationIds.appartements.length > 0) {
            programmationIds.appartements.forEach((id, index) => {
              donnees_visites_specifiques.push({
                fk_programmation_appartement: id,
                prix_vente_unitaire_min:
                  filteredFormData.appartements_prices[index]
                    .prix_vente_unitaire_min,
                prix_vente_unitaire_max:
                  filteredFormData.appartements_prices[index]
                    .prix_vente_unitaire_max,
                prix_vente_min:
                  filteredFormData.appartements_prices[index].prix_vente_min,
                prix_vente_max:
                  filteredFormData.appartements_prices[index].prix_vente_max,
                prix_loyer_min:
                  filteredFormData.appartements_prices[index].prix_loyer_min,
                prix_loyer_max:
                  filteredFormData.appartements_prices[index].prix_loyer_max,
                isPrixParkingInclus:
                  filteredFormData.appartements_prices[index]
                    .isPrixParkingInclus,
                prixParking:
                  filteredFormData.appartements_prices[index].prixParking,
                nbr_unites_total:
                  filteredFormData.appartements_prices[index].nbr_unites_total,
                nbr_unites_vendues:
                  filteredFormData.appartements_prices[index]
                    .nbr_unites_vendues,
                nbr_unites_invendues:
                  filteredFormData.appartements_prices[index]
                    .nbr_unites_invendues,
              });
            });
          }

          // Add villas prices
          if (programmationIds.villas.length > 0) {
            programmationIds.villas.forEach((id, index) => {
              donnees_visites_specifiques.push({
                fk_programmation_villas: id,
                prix_vente_unitaire_min:
                  filteredFormData.villas_prices[index].prix_vente_unitaire_min,
                prix_vente_unitaire_max:
                  filteredFormData.villas_prices[index].prix_vente_unitaire_max,
                prix_vente_min:
                  filteredFormData.villas_prices[index].prix_vente_min,
                prix_vente_max:
                  filteredFormData.villas_prices[index].prix_vente_max,
                prix_loyer_min:
                  filteredFormData.villas_prices[index].prix_loyer_min,
                prix_loyer_max:
                  filteredFormData.villas_prices[index].prix_loyer_max,
                isPrixParkingInclus:
                  filteredFormData.villas_prices[index].isPrixParkingInclus,
                prixParking: filteredFormData.villas_prices[index].prixParking,
                nbr_unites_total:
                  filteredFormData.villas_prices[index].nbr_unites_total,
                nbr_unites_vendues:
                  filteredFormData.villas_prices[index].nbr_unites_vendues,
                nbr_unites_invendues:
                  filteredFormData.villas_prices[index].nbr_unites_invendues,
              });
            });
          }

          // Add bureaux prices
          if (programmationIds.bureaux.length > 0) {
            programmationIds.bureaux.forEach((id, index) => {
              donnees_visites_specifiques.push({
                fk_programmation_bureau: id,
                prix_vente_unitaire_min:
                  filteredFormData.bureaux_prices[index]
                    .prix_vente_unitaire_min,
                prix_vente_unitaire_max:
                  filteredFormData.bureaux_prices[index]
                    .prix_vente_unitaire_max,
                prix_vente_min:
                  filteredFormData.bureaux_prices[index].prix_vente_min,
                prix_vente_max:
                  filteredFormData.bureaux_prices[index].prix_vente_max,
                prix_loyer_min:
                  filteredFormData.bureaux_prices[index].prix_loyer_min,
                prix_loyer_max:
                  filteredFormData.bureaux_prices[index].prix_loyer_max,
                isPrixParkingInclus:
                  filteredFormData.bureaux_prices[index].isPrixParkingInclus,
                prixParking: filteredFormData.bureaux_prices[index].prixParking,
                nbr_unites_total:
                  filteredFormData.bureaux_prices[index].nbr_unites_total,
                nbr_unites_vendues:
                  filteredFormData.bureaux_prices[index].nbr_unites_vendues,
                nbr_unites_invendues:
                  filteredFormData.bureaux_prices[index].nbr_unites_invendues,
              });
            });
          }

          // Add locaux_commerciaux prices
          if (programmationIds.locaux_commerciaux.length > 0) {
            programmationIds.locaux_commerciaux.forEach((id, index) => {
              donnees_visites_specifiques.push({
                fk_programmation_lc: id,
                prix_vente_unitaire_min:
                  filteredFormData.locaux_commerciaux_prices[index]
                    .prix_vente_unitaire_min,
                prix_vente_unitaire_max:
                  filteredFormData.locaux_commerciaux_prices[index]
                    .prix_vente_unitaire_max,
                prix_vente_min:
                  filteredFormData.locaux_commerciaux_prices[index]
                    .prix_vente_min,
                prix_vente_max:
                  filteredFormData.locaux_commerciaux_prices[index]
                    .prix_vente_max,
                prix_loyer_min:
                  filteredFormData.locaux_commerciaux_prices[index]
                    .prix_loyer_min,
                prix_loyer_max:
                  filteredFormData.locaux_commerciaux_prices[index]
                    .prix_loyer_max,
                nbr_unites_total:
                  filteredFormData.locaux_commerciaux_prices[index]
                    .nbr_unites_total,
                nbr_unites_vendues:
                  filteredFormData.locaux_commerciaux_prices[index]
                    .nbr_unites_vendues,
                nbr_unites_invendues:
                  filteredFormData.locaux_commerciaux_prices[index]
                    .nbr_unites_invendues,
              });
            });
          }

          const visiteData = {
            fk_tranche: filteredFormData.fk_tranche,
            utilisateur: filteredFormData.utilisateur,
            date_visite: filteredFormData.date_visite,
            bureau_de_vente: filteredFormData.bureau_de_vente,
            contact_agent_commercial: filteredFormData.contact_agent_commercial,
            etat_des_ventes: filteredFormData.etat_des_ventes,
            pratique_noir: filteredFormData.pratique_noir,
            date_debut_commercialisation:
              filteredFormData.date_debut_commercialisation, 
            date_fin_commercialisation:
              filteredFormData.date_fin_commercialisation, 
            livraison_immediate: filteredFormData.livraison_immediate,
            date_livraison: filteredFormData.date_livraison, 
            nbr_unites_appartements_vendues:
              formData.nbr_unites_appartements_vendues,
            nbr_unites_appartements_invendues:
              formData.nbr_unites_appartements_invendues,
            nbr_unites_villas_vendues: formData.nbr_unites_villas_vendues,
            nbr_unites_villas_invendues: formData.nbr_unites_villas_invendues,
            nbr_unites_bureaux_vendues: formData.nbr_unites_bureaux_vendues,
            nbr_unites_bureaux_invendues: formData.nbr_unites_bureaux_invendues,
            nbr_unites_lc_vendues: formData.nbr_unites_lc_vendues,
            nbr_unites_lc_invendues: formData.nbr_unites_lc_invendues,
            donnees_visites_specifiques,
          };

          const addVisiteResult = await dispatch(addVisite(visiteData));
          const visiteId = addVisiteResult.payload;

          // Upload Photos

          await uploadPhotosByCategory(
            fileListBureauVente,
            visiteId,
            "bureau_vente"
          );
          await uploadPhotosByCategory(
            fileListExterieurProjet,
            visiteId,
            "exterieur_projet"
          );
          await uploadPhotosByCategory(
            fileListChantier,
            visiteId,
            "construction/chantier"
          );
          await uploadPhotosByCategory(
            fileListEquipementSportif,
            visiteId,
            "equipement_sportif"
          );
          await uploadPhotosByCategory(fileListTemoins, visiteId, "temoins");
          await uploadPhotosByCategory(fileListPiscine, visiteId, "piscine");
          await uploadPhotosByCategory(fileListParking, visiteId, "parking");
          await uploadPhotosByCategory(fileListAutres, visiteId, "autres");
          
          
          
            await dispatch(
              completeProject({
                idProjet: filteredFormData.fk_nom_du_projet,
                idUser: connectedUser?.id,
              })
            );
          

          // Reset form and state
          await resetDraftAndForm();
        })(),
        {
          loading: "Traitement en cours...",
          success: "Visite crée avec succés!",
          error: "Une erreur est survenue lors de l'enregistrement.",
        }
      );
    } catch (error) {
      console.error("Error processing onFinish:", error);
      toast.error("Une erreur est survenue.");
    }
  };

  // Reset draft
  const resetDraftAndForm = async () => {
    try {
      setLoading(true);
      await resetBrouillonApi();
      form.resetFields();
      setIsSousSolExistant(false);
      setIsParkingAppartementsAvailable(false);
      setIsParkingVillasAvailable(false);
      setIsAscenseurAvailable(false);
      setIsParTranche(false);
      setTranchesOptions([]);
      setIsEnChantier(false);
      setFormData(initialState);
      setCurrent(0);
      setDraftLoaded(false);
    } catch (error) {
      console.error("Error resetting draft:", error);
    } finally {
      setLoading(false);
    }
  };

  // Save form state as draft
  const saveDraft = async () => {
    try {
      setLoading(true);
      // Get current form values
      const currentFormValues = await form
        .validateFields()
        .catch(() => form.getFieldsValue());

      // Merge with existing state
      const updatedFormState = { ...formData, ...currentFormValues };

      // Add the additional state information
      const enhancedFormState = {
        ...prepareDayjsFieldsForStorage(updatedFormState),
        _meta: {
          isParTranche: isParTranche,
          tranchesOptions: tranchesOptions,
        },
      };

      // Save to backend using your existing API structure
      await addBrouillonApi(enhancedFormState, current);

      // Update local state
      setFormData(updatedFormState);

      toast.success("Brouillon enregistré avec succés");
    } catch (error) {
      console.error("Error saving draft:", error);
      toast.error("Failed to save draft");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
     const loadDraft = async () => {
      try {
        setLoading(true);
        const draft = await getBrouillonApi();
        if (draft) {
          // Extract the form state and metadata
          const { _meta, ...formStateData } = draft.form_state;

          const restoredData = restoreDayjsFields(formStateData);
          setFormData(restoredData);
          form.setFieldsValue(restoredData);
          setCurrent(draft.current_step);

          // Restore metadata if it exists
          if (_meta) {
            if (_meta.isParTranche !== undefined) {
              setIsParTranche(_meta.isParTranche);
            }

            if (_meta.tranchesOptions && Array.isArray(_meta.tranchesOptions)) {
              setTranchesOptions(_meta.tranchesOptions);
            }
          }

          // Set other state variables
          setDraftLoaded(true);
          if (restoredData.parking_appartements)
            setIsParkingAppartementsAvailable(true);
          if (restoredData.parking_villas) setIsParkingVillasAvailable(true);
          if (restoredData.ascenseur) setIsAscenseurAvailable(true);
          if (restoredData.sous_sol) setIsSousSolExistant(true);
          if (restoredData.phase_du_projet === "en chantier")
            setIsEnChantier(true);
        }
      } catch (error) {
        console.error("Error loading draft:", error);
        toast.error("Failed to load draft");
      } finally {
        setLoading(false);
      }
    };

    loadDraft();
  }, [form]);

  useEffect(() => {
    dispatch(fetchUsersWithProjects());
  }, [dispatch]);

  useEffect(() => {
    scrollToFormTop();
  }, [current]);

  useEffect(() => {
    form.setFieldsValue(formData);
  }, [form, formData]);

  // Update userProjects when usersWithProjects changes
  useEffect(() => {
    if (usersWithProjects.length > 0 && user) {
      const connectedUser = usersWithProjects.find((u) => u.id === user.id);
      if (connectedUser) {
        setUserProjects(connectedUser.projets);
        console.log(connectedUser.projets);
      }
    }
  }, [usersWithProjects, user]);

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 575px)" });

  return (
    <div style={{ maxWidth: "100vw", overflowX: "hidden" }}>
      {/* Wrap your components in the App component */}
      <S.StepWrapper>
        <Spin indicator={<LoadingOutlined spin />} spinning={loading}>
          <S.StyledSteps
            progressDot
            size="small"
            direction={isTabletOrMobile ? "vertical" : "horizontal"}
            current={current}
            style={{
              padding: "10px 10px",
              marginBottom: "20px",
              width: "100%",
            }}
          >
            {steps.map((item, index) => (
              <Step key={item.title} title={item.title} />
            ))}
          </S.StyledSteps>
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            onValuesChange={handleValuesChange}
            initialValues={initialState}
            style={{
              flex: 1,
              width: "100%",
              overflow: "hidden",
              padding: "10px",
            }}
          >
            <div
              style={{
                marginBottom: "20px",
                width: "100%",
                overflowX: "auto",
                WebkitOverflowScrolling: "touch",
              }}
            >
              {steps[current].content}
            </div>

            <Row style={{ width: "100%" }} justify={"center"}>
              <Col
                xs={24}
                sm={24}
                md={12}
                lg={12}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div>
                  <Button
                    onClick={resetDraftAndForm}
                    style={{ marginRight: "20px" }}
                    icon={<ReloadOutlined />}
                  ></Button>
                  <Button
                    icon={<SaveOutlined />}
                    color="default"
                    variant="filled"
                    onClick={saveDraft}
                  ></Button>
                </div>

                <div>
                  {current > 0 && (
                    <Button
                      icon={<LeftCircleOutlined />}
                      onClick={prev}
                      style={{ marginRight: "20px" }}
                    >
                      {isMobile ? "" : "Précédent"}
                    </Button>
                  )}
                  {current < steps.length - 1 && (
                    <Button
                      icon={<RightCircleOutlined />}
                      iconPosition="end"
                      type="primary"
                      onClick={next}
                    >
                      {isMobile ? "" : "Suivant"}
                    </Button>
                  )}
                  {current === steps.length - 1 && (
                    <Button
                      icon={<CheckOutlined />}
                      type="primary"
                      htmlType="submit"
                    >
                      Confirmer
                    </Button>
                  )}
                </div>
              </Col>
            </Row>
          </Form>
        </Spin>
      </S.StepWrapper>
    </div>
  );
}
